import Palette from './Palette';

const palette = new Palette('CPK', 'CP');

// DO NOT EDIT MANUALLY! Autogenerated from atom_types.csv by atom_types.py.
palette.elementColors = {
  /* eslint-disable no-magic-numbers */
  H: 0xFFFFFF,
  C: 0x202020,
  N: 0x2060FF,
  O: 0xEE2010,
  F: 0x00FF00,
  P: 0x8020FF,
  S: 0xFFFF00,
  CL: 0x00BB00,
  FE: 0xD0D0D0,
  CO: 0xD0D0D0,
  NI: 0xD0D0D0,
  CU: 0xD0D0D0,
  BR: 0x008800,
  I: 0x005500,
  /* eslint-enable no-magic-numbers */
};

export default palette;
